module.exports = __webpack_public_path__ + "static/media/5.2d4781a3.png";